import React from 'react';
import './ErrorPage.scss';
import { Button } from '@ampol/design-system';

/**
 * An error page container
 * @param fullScreen Sets the background image as fullscreen, covering the header and footer
 * @param heading Heading of the error page
 * @param errorCode Error code of the error page
 * @param message Message of the error page
 * @param buttonLabel Label of the error page button
 * @param buttonAction Function action of error page button on click
 * @returns JSX Element
 */

const ErrorPage = ( { fullScreen = false, heading, errorCode, message, buttonLabel, buttonAction }) => {
  return <>
    <div className={`error-page ${fullScreen && 'error-page--full-screen'}`}>
      <div className='error-page__content'>
        <h1 className='error-page__heading'>{heading}</h1>
        <div className='error-page__message'>{errorCode && ('Error ' + errorCode + ': ')}{message}</div>
        {buttonLabel && <Button
          color="blue"
          label={buttonLabel}
          variant="secondary"
          onClick={buttonAction}
        />}
      </div>
    </div>
  </>;
};

export default ErrorPage;
